module.exports = "<!-- <ul>\n  <li *ngFor=\"let item of items | async\">\n    {{ item.name }}\n  </li>\n</ul> -->\n\n<router-outlet></router-outlet>\n"